// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "思想道德与法治",
      "tec": "赵世龙",
      "week": "6-17周",
      "add": "教学楼C座302教务"
    },
    {
      "sub": "人工智能与计算机基础应用",
      "tec": "孙晋",
      "week": "11-17周",
      "add": "实训楼C座308"
    },
    {
      "sub": "高等数学",
      "tec": "李丽",
      "week": "6-19周",
      "add": "教学楼C座303教务"
    },
    [
      {
        "sub": "工程制图与识图",
        "tec": "王石",
        "week": "6-11周",
        "add": "教学楼C座111教务"
      },
      {
        "sub": "工程制图与识图",
        "tec": "王石",
        "week": "12-13周",
        "add": "实训楼C座108"
      }
    ],
    [
      {
        "sub": "工程力学",
        "tec": "孙长青",
        "week": "6-10周",
        "add": "教学楼C座115教务"
      },
      {
        "sub": "工程力学",
        "tec": "孙长青",
        "week": "11-13周",
        "add": "教学楼C座115教务"
      }
    ]
  ],
  "2": [
    [
      {
        "sub": "综合英语1",
        "tec": "于轶",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "109国教",
        "tec": "钱祺",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "101国教",
        "tec": "孙琪",
        "week": "6-18周",
        "add": "动2"
      },
      {
        "sub": "107国教",
        "tec": "刘德娟",
        "week": "6-18周",
        "add": "动2"
      }
    ],
    {
      "sub": "高等数学",
      "tec": "李丽",
      "week": "6-19周",
      "add": "教学楼C座311教务"
    },
    {
      "sub": "体育",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[05-06节]）"
    },
    0,
    {
      "sub": "职业健康与安全",
      "tec": "马珊珊",
      "week": "12-18周",
      "add": "教学楼C座113教务"
    }
  ],
  "3": [
    [
      {
        "sub": "交际口语1",
        "tec": "外教7",
        "week": "6-18周",
        "add": "动4"
      },
      {
        "sub": "108国教",
        "tec": "外教8",
        "week": "6-18周",
        "add": "动4"
      },
      {
        "sub": "106国教",
        "tec": "外教6",
        "week": "6-18周",
        "add": "动4"
      },
      {
        "sub": "104国教",
        "tec": "外教9",
        "week": "6-18周",
        "add": "动4"
      }
    ],
    {
      "sub": "思想道德与法治",
      "tec": "赵世龙",
      "week": "6-17周",
      "add": "教学楼C座303教务"
    },
    0,
    0,
    [
      {
        "sub": "工程力学",
        "tec": "孙长青",
        "week": "11-13周",
        "add": "教学楼C座115教务"
      },
      {
        "sub": "军事理论",
        "tec": "孔瀚",
        "week": "14-18周",
        "add": "教学楼C座113教务"
      }
    ]
  ],
  "4": [
    {
      "sub": "高等数学",
      "tec": "李丽",
      "week": "6-19周",
      "add": "教学楼C座311教务"
    },
    [
      {
        "sub": "综合英语1",
        "tec": "钱祺",
        "week": "6-18周",
        "add": "动1"
      },
      {
        "sub": "101国教",
        "tec": "刘德娟",
        "week": "6-18周",
        "add": "动1"
      },
      {
        "sub": "105国教",
        "tec": "孙琪",
        "week": "6-18周",
        "add": "动1"
      },
      {
        "sub": "107国教",
        "tec": "于轶",
        "week": "6-18周",
        "add": "动1"
      }
    ],
    [
      {
        "sub": "形势与政策",
        "tec": "王树平",
        "week": "6-9周",
        "add": "教学楼A座225电力"
      },
      {
        "sub": "职业健康与安全",
        "tec": "马珊珊",
        "week": "12-18周",
        "add": "教学楼C座113教务"
      }
    ],
    {
      "sub": "人工智能与计算机基础应用",
      "tec": "孙晋",
      "week": "11-17周",
      "add": "实训楼C座308"
    },
    [
      {
        "sub": "工程制图与识图",
        "tec": "王石",
        "week": "6-11周",
        "add": "教学楼C座111教务"
      },
      {
        "sub": "工程制图与识图",
        "tec": "王石",
        "week": "12-13周",
        "add": "实训楼C座108"
      },
      {
        "sub": "就业创业指导",
        "tec": "刘思园",
        "week": "14-18周",
        "add": "教学楼C座113教务"
      }
    ]
  ],
  "5": [
    0,
    [
      {
        "sub": "工程力学",
        "tec": "孙长青",
        "week": "6-10周",
        "add": "教学楼C座114教务"
      },
      {
        "sub": "人工智能与计算机基础应用",
        "tec": "孙晋",
        "week": "11-17周",
        "add": "实训楼C座308"
      }
    ],
    {
      "sub": "心理健康与调适",
      "tec": "贲立欣",
      "week": "6-15周",
      "add": "教学楼A座117电力"
    },
    [
      {
        "sub": "工程制图与识图",
        "tec": "王石",
        "week": "6-11周",
        "add": "教学楼C座111教务"
      },
      {
        "sub": "工程制图与识图",
        "tec": "王石",
        "week": "12-13周",
        "add": "实训楼C座108"
      },
      {
        "sub": "军事理论",
        "tec": "孔瀚",
        "week": "15-18周",
        "add": "教学楼C座113教务"
      }
    ],
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
